export const colorPallette = {
    CYAN_BLUE: 'rgb(95, 116, 130)',
    WHITE: 'rgb(255, 255, 255)',
    BLUE: 'rgb(26, 105, 242)',
    GREEN: 'rgb(23, 208, 122)',
    SMOKE_GREY: 'rgb(97,97,97)'
}